import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 30 28" {...props}>
      <title id="Code">{props.title || 'Code'}</title>
      <g>
        <path d="M.7 15c0-.1.1-.3.2-.4l7.3-7.3c.1-.1.2-.2.4-.2.1 0 .3.1.4.2l.8.8c.1.1.2.2.2.4l-.4.4-6.1 6.1 6.1 6.1c.1.1.2.2.2.4 0 .1-.1.3-.2.4l-.8.8c-.1.1-.2.2-.4.2s-.3-.1-.4-.2l-7.3-7.3c.1-.1 0-.3 0-.4zm10.4 9.8l5.9-20.2c0-.1.1-.2.2-.3s.2-.1.4 0l1 .3c.1 0 .2.1.3.2s.1.2 0 .4l-5.9 20.2c0 .1-.1.2-.2.3s-.2.1-.4 0l-1-.3c-.1 0-.2-.1-.3-.2v-.4zm9.1-3.3c0-.1.1-.3.2-.4l6.1-6.1-6.1-6.1c-.1-.1-.2-.2-.2-.4 0-.1.1-.3.2-.4l.8-.8c.1-.1.2-.2.4-.2s.3.1.4.2l7.3 7.3c.1.1.2.2.2.4 0 .1-.1.3-.2.4l-7.3 7.3c-.1.1-.2.2-.4.2-.1 0-.3-.1-.4-.2l-.8-.8c-.1-.1-.2-.3-.2-.4z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/code.js